module.exports = __webpack_public_path__ + "img/playIcon.16a8e04d.png";